// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uNYy","largestCol":"styles_largestCol__23BEk","smallestCol":"styles_smallestCol__1q0hP"};